import { render, staticRenderFns } from "./Regalo.vue?vue&type=template&id=e8d4db2a&"
import script from "./Regalo.vue?vue&type=script&lang=js&"
export * from "./Regalo.vue?vue&type=script&lang=js&"
import style0 from "./Regalo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports